export class KeycodeConstants {
   public static readonly Backspace = 8;
   public static readonly Delete = 46;
   public static readonly Period = 190;
}
